<template>
	<div
		v-if="false"
		class="container sub-bottom mb-30"
	>
		<div
			class="mt-30 hide-pc"
		>
			<ul
				class=""
			>
				<template
					v-for="(menu, m_index) in items_menu"
				>
					<li
						v-if="!menu.not_view"
						:key="'menu_' + m_index"
						class="ptb-15 justify-space-between under-line size-px-16 font-weight-600 items-center cursor-pointer"
						:class="{ on: menu.title == item.title}"
						@click="toMenu(menu)"
					>
						{{ menu.title }}

						<v-icon>mdi mdi-chevron-right</v-icon>
					</li>
				</template>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SubBottom'
	, props: ['user', 'program']
	, data: function(){
		return {
			items_menu: [
				{
					name: 'point'
					, title: '포인트 내역'
					, to: 'PointHistory'
					, not_view: true
				}
				, {
					name: 'point'
					, title: '포인트 결제 내역'
					, to: 'PointList'
					, not_view: true
				}
				, {
					name: 'present'
					, title: '포인트 선물'
					, to: 'PointPresent'
					, not_view: true
				}
				, {
					name: 'present'
					, title: '주문 내역'
					, to: 'OrderList'
					, params: {
						type: 'order'
					}
				}
				, {
					name: 'issue'
					, title: '취소/환불'
					, to: 'OrderCancel'
					, params: {
						type: 'cancel'
					}
				}
				, {
					name: 'qna'
					, title: '1:1문의'
					, to: 'CustomerCenter'
					, params: {
						b_code: 'b_qna'
					}
				}
				, {
					name: 'wish'
					, title: '관심상품'
					, to: 'Wish'
				}
			]
		}
	}
	, computed: {

		item: function(){
			let t = {
			}

			this.items_menu.filter( (item) => {
				if(item.to == this.$route.name){
					t = item
				}
			})

			return t
		}
	}
	, methods: {
		toModify: function(){
			this.$bus.$emit('to', {name: 'Modify'})
		}
		, toMenu: function(item){
			this.$bus.$emit('to', {name: item.to, params: item.params})
		}
	}
	, created() {

	}
}
</script>

<style>
.sub-top .on2 {
	background-color: var(--bg-base);
	border-color: var(--primary) !important;
	color: var(--primary);
}
.sub-top .bg-default{
	border-color: var(--bg-dark);
}
</style>